import { OrderStatusEnum } from '@ztechapps/common.contract'

export function createDefault(newValue?: any) {
  const defaultValue = {
    status: OrderStatusEnum.Quotation,
  }

  return { ...defaultValue, ...newValue }
}
